import { render, staticRenderFns } from "./HistoryDialog.vue?vue&type=template&id=79dfb889&"
import script from "./HistoryDialog.vue?vue&type=script&lang=js&"
export * from "./HistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports